import React from 'react'
import { Spinner } from 'react-bootstrap'
import { UnifiedSearchTab } from './constants'

interface UnifiedSearchEmptyStateProps {
  debouncedSearchTerm: string
  isLoading: boolean
  selectedTab: UnifiedSearchTab
  hasResults: boolean
}

export function UnifiedSearchEmptyState({
  debouncedSearchTerm,
  isLoading,
  selectedTab,
  hasResults,
}: UnifiedSearchEmptyStateProps) {
  if (!debouncedSearchTerm) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <p className="text-gray-500 text-lg">Start typing to search...</p>
          <p className="text-gray-400 text-sm">
            Search companies, locations, products, and deals by name, domain,
            address, ID, or SKU
          </p>
        </div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Spinner />
      </div>
    )
  }

  if (!hasResults) {
    const getEmptyMessage = () => {
      switch (selectedTab) {
        case 'firstbite':
          return 'No First Bite chain results found'
        case 'firstbitedoors':
          return 'No First Bite door results found'
        case 'unmatcheddoors':
          return 'No unmatched door results found'
        case 'variants':
          return 'No product variant results found'
        default:
          return 'No unmatched chain results found'
      }
    }

    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <p className="text-gray-500 text-lg">{getEmptyMessage()}</p>
          <p className="text-gray-400 text-sm">
            Try adjusting your search or filters
          </p>
        </div>
      </div>
    )
  }

  return null
}
